import styled from "styled-components";
import GlobalColors from "../../styles/colors";

export const SpanStyled = styled.span`
    color: ${GlobalColors.PRIMARY};
    cursor: pointer;
`;